const CLI_PORT = 7331;
const CLI_BASE = `http://localhost:${CLI_PORT}`;

export interface CliStatus {
  ok: true;
  version: string;
  user: string | null;
  lastSyncAt: string | null;
}

export interface CliInstallResult {
  ok: true;
  installedPaths: string[];
}

export async function pingCli(): Promise<CliStatus | null> {
  try {
    const res = await fetch(`${CLI_BASE}/status`, { method: 'GET' });
    if (!res.ok) return null;
    return (await res.json()) as CliStatus;
  } catch {
    return null;
  }
}

export async function installViaCli(skillId: string): Promise<CliInstallResult> {
  const res = await fetch(`${CLI_BASE}/install/${encodeURIComponent(skillId)}`, {
    method: 'POST',
  });
  if (!res.ok) throw new Error(`CLI install failed: HTTP ${res.status}`);
  return (await res.json()) as CliInstallResult;
}
